import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types/src/application.tsx';
import {
	FREE_EDITION,
	getEdition,
	STANDARD_EDITION,
	PREMIUM_EDITION,
	UNLICENSED,
} from '@atlassian/jira-shared-types/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useIsStandardJSW = (): boolean => {
	const appEditions = useAppEditions();
	const jswEdition = appEditions ? getEdition(JIRA_SOFTWARE, appEditions) : undefined;
	return jswEdition === STANDARD_EDITION;
};

export const useIsFreeJSW = (): boolean => {
	const appEditions = useAppEditions();
	const jswEdition = appEditions ? getEdition(JIRA_SOFTWARE, appEditions) : undefined;
	return jswEdition === FREE_EDITION;
};

export const useIsStandardOrFreeJSW = (): boolean => {
	const appEditions = useAppEditions();
	const jswEdition = appEditions ? getEdition(JIRA_SOFTWARE, appEditions) : undefined;
	return jswEdition === STANDARD_EDITION || jswEdition === FREE_EDITION;
};

export const useIsPremiumJSW = (): boolean => {
	const appEditions = useAppEditions();
	const jswEdition = appEditions ? getEdition(JIRA_SOFTWARE, appEditions) : undefined;
	return jswEdition === PREMIUM_EDITION;
};

export const useIsUnlicensedJSW = (): boolean => {
	const appEditions = useAppEditions();
	const jswEdition = appEditions ? getEdition(JIRA_SOFTWARE, appEditions) : undefined;
	return !jswEdition || jswEdition === UNLICENSED;
};
